import {
  fetchCianApiSiteV1OffersSearchMeta,
  TCianApiSiteV1OffersSearchMetaRequest,
  TCianApiSiteV1OffersSearchMetaResponse,
} from '../repositories/monolith-python/cian-api/site/v1/offers/search/meta';
import { IApplicationContext } from '../types/application';
import { ISearchMetaResponseSchema } from '../repositories/monolith-python/entities/schemas/SearchMetaResponseSchema';

interface IGetMetaParameters {
  context: IApplicationContext;
  subdomain: string;
  parameters: TCianApiSiteV1OffersSearchMetaRequest;
}

export async function fetchSearchMeta({
  context,
  subdomain,
  parameters,
}: IGetMetaParameters): Promise<ISearchMetaResponseSchema | null> {
  const { httpApi, logger } = context;

  try {
    const response: TCianApiSiteV1OffersSearchMetaResponse = await fetchCianApiSiteV1OffersSearchMeta({
      httpApi,
      parameters,
      config: {
        subdomain,
      },
    });

    if (response.statusCode !== 200) {
      logger.warning(response.response.data.message || 'Код ответа не 200', {
        domain: 'getMeta',
        message: 'Не удалось выполнить запрос к getMeta',
        error: JSON.stringify(response.response.data.errors || {}),
        parameters: JSON.stringify(parameters),
      });

      return null;
    }

    return response.response.data;
  } catch (error) {
    logger.error(error, {
      domain: 'getMeta',
      message: 'Не удалось выполнить запрос к getMeta',
    });

    return null;
  }
}
